import React, {useState} from "react";
import "./ComponentResultsNoIMG.css";

import {MonthToText} from "../../../../../AdminPart/src/Constants";
import QueryContestInfoByID from "./QueryContestInfoByID/QueryContestInfoByID";
import TextChange from "../../../../../AdminPart/src/Elements/TextChange/TextChange";
// мы получаем AllResults - {_id: уникальный_номер, ContestDate, ContestName, Itog : набор счетов со свойствами} А нам нужно два массива -
// слева где будет {year:[{date: дата, _id: уникальный_номер, active: активность}]}
// справа где {_id: уникальный_номер, Itog : набор счетов со свойствами}
// Если я кликаю на элементе конкурса слева - то меняется ActiveDays -
const PRERENDER_TEXTS = require("../../../../../prerender_base.js");

function ComponentResultsNoIMG(props){
    function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
    } else {try {return <>{JSON.parse(PRERENDER_TEXTS['ContestInfo'][info.ArrIndex])[props.lang] ? JSON.parse(PRERENDER_TEXTS['ContestInfo'][info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}

    const [ContestID, setContestID] = useState(props.ContestID);
    const [AllContests, setAllContests] = useState(props.AllContests);
    const [PhoneChangeContestWindow, setPhoneChangeContestWindow] = useState(false);
    const [CurrentYear, setCurrentYear] = useState(props.CurrentYear);

    function DelActive() {setPhoneChangeContestWindow(!PhoneChangeContestWindow);}
    function ChangeActiveContest(year,ContestIDThis) {
        console.log('11111',props.AllContests,CurrentYear,ContestID,ContestID)
        const AllContests = props.AllContests;
        AllContests[CurrentYear][ContestID].active = false;
        AllContests[year][ContestIDThis].active = true;
        setAllContests(AllContests);
        setContestID(ContestIDThis);
        setPhoneChangeContestWindow(!PhoneChangeContestWindow);
        setCurrentYear(year);
    }

    function AllContestsToFormatWeNeed(AllContests,self,lang,TextElement) {
        /**
         * @return {string}
         */
        function DateContestGoodView(ContestDate) {//Мы пока не сделали - но возможно мы должны добавлять день - потому что все конкурсы начинаются за день до этого - потому что по ГМТ - скажем конкурс начался
            // console.log('ContestDate',ContestDate); // Проблема в том что мы когда новость делаем - мы ставим дату подведения. А база создается на дату начала
            const ContestDateArray = ContestDate.split('-');
            let Day = ContestDateArray[1];
            return Day + ' ' + MonthToText(ContestDateArray[0],lang);
        }
        try{

            return Object.keys(AllContests).sort((a, b) => {if (b < a) {return -1} else {return 1}}).map(function(year,index) {
                const ContestOfThisYear = Object.values(AllContests[year]).map(
                    function (Contest) {return <div className='TraderContestResultsDatesElementOut' key={Contest.ContestDateID}>
                        <div className={(Contest.active ? 'TraderContestResultsDatesElementActive' : 'TraderContestResultsDatesElement')} key={Contest.ContestDateID}
                             role = "button" tabIndex={0} onClick={() => ChangeActiveContest(year,Contest.ContestDateID)}>
                            <div className='TraderContestResultsElementTop' >{DateContestGoodView(Contest.ContestDate)} </div>
                            <div className='TraderContestResultsElementBottom' >{TextElement}</div>
                        </div></div>}
                );

                return <div className='ContestResultsYear' key={index}>
                    <div className='ContestResultsYearTitle'>{year}</div>
                    {ContestOfThisYear}
                </div>
            });
        } catch (e) {
            console.log(e);
        }
    }

        //console.log('99999',props.data)
        const AllContestsResult = AllContestsToFormatWeNeed(AllContests,this,props.lang, {'ru': 'Новичок','en': 'Newbie','cn': 'Newbie'}[props.lang]); // Слева перечень конкурсов - мы его преобразуем в формат годы - список.

        return (
            <div className="TraderContestResults">
                <div className={"TraderContestResultsDates " + (PhoneChangeContestWindow ? 'ResultsPhoneVisible': 'ResultsPhoneNoVisible')}>
                    <div className="TraderContestResultsDatesTitle"><TextSource ArrIndex= 'ContestInfo0010'>Выберите конкурс</TextSource></div>
                    {AllContestsResult}
                </div>
                <div className={(PhoneChangeContestWindow ? 'StandartAllBlack500': 'isNoVisible')}  onClick={() => DelActive()} role="button" tabIndex={0}> </div>
            <QueryContestInfoByID ContestID={ContestID} lang={props.lang} Prerender_texts = {PRERENDER_TEXTS['ContestInfo']} />
            </div>
        )}

export default ComponentResultsNoIMG